import * as types from '@/store/types'
import MagazinesWorker from '@/workers/savePdf.worker'
import { toggleExportingPdf } from '@/store/actions'

const worker = new MagazinesWorker()

const saveMagazineToPdfMiddleware = store => next => action => {
  if ( action.type !== types.EXPORTI_PDF ) {
    return next( action )
  }

  const { content, magazineId, magazineName, userId } = action.payload

  worker.postMessage( {
    type: 'save',
    magazineId: magazineId,
    html: content,
    magazineName: magazineName,
    userId: userId
  } )

  worker.onmessage = ( { data } ) => {
    const exported = store.getState().magazines.exportingPdf.exportedMagazines
    const updated = exported.filter( item => item.date !== data.date )
    updated.push( data )
    next(
      toggleExportingPdf( {
        magazineId: null,
        content: null,
        exporting: false,
        exportedMagazines: updated
      } )
    )
  }
  return next( action )
}

const retriveSavedPdfsMiddleware = store => next => action => {
  if ( action.type !== types.SET_USER ) {
    return next( action )
  }

  if ( !action.payload || !action.payload.user ) {
    return next( action )
  }

  worker.postMessage( {
    type: 'get',
    userId: action.payload.user.id_usuario
  } )

  worker.onmessage = ( { data } ) => {
    return next(
      toggleExportingPdf( {
        magazineId: null,
        content: null,
        exporting: false,
        exportedMagazines: data
      } )
    )
  }

  return next( action )
}

const updateSavedPdf = store => next => action => {
  if ( action.type === types.UPDATE_PDF_STATUS ) {
    worker.postMessage( {
      type: 'put',
      id: action.payload.id
    } )
    worker.onmessage = () => {}
  }
  next( action )
}

export default [
  saveMagazineToPdfMiddleware,
  retriveSavedPdfsMiddleware,
  updateSavedPdf
]



// WEBPACK FOOTER //
// ./src/store/mniddlewares/magazines.middleware.js